import * as Sentry from '@sentry/browser';
import {  } from '@sentry/integrations';
import { Plugin } from '@nuxt/types';
import Vue from 'vue';

const SentryPlugin: Plugin = (context, inject) => {
  const dsn = context.$config.sentryDsn;
  const release = context.$config.sentryRelease;

  if (dsn) {
    Sentry.init({
      dsn,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      autoSessionTracking: true,
      release,
      environment: context.$config.sentryEnvironment,
    });

    Vue.config.errorHandler = (error, vm, info) => {
      Sentry.withScope((scope) => {
        scope.setExtra('info', info);
        Sentry.captureException(error);
      });
    }
    console.log('Sentry initialized');
  } else {
    console.warn('Sentry DSN not found');
  }
};

export default SentryPlugin;
